export const NAME = 'bankcreditcard';

export const REQUEST_BANK_CREDIT_CARD = 'REQUEST_BANK_CREDIT_CARD';
export const RECEIVE_BANK_CREDIT_CARD = 'RECEIVE_BANK_CREDIT_CARD';
export const FAILURE_BANK_CREDIT_CARD = 'FAILURE_BANK_CREDIT_CARD';



// WEBPACK FOOTER //
// ./src/services/bankcreditcard/constants.js